// ─── src/api/mentors.ts ───────────────────────────────────────────────────────

import { apiClient } from "./registration";
import type { MentorsResponse, MentorParams } from "../types/mentor";
import type { PaginationMeta } from "../types/registration";
import type { Mentor } from "../types/mentor";

export interface NormalisedMentorsResponse {
  data: Mentor[];
  meta: PaginationMeta;
}

const normalise = (raw: MentorsResponse): NormalisedMentorsResponse => ({
  data: raw.data,
  meta: {
    total:      raw.total,
    page:       raw.page,
    limit:      raw.limit,
    totalPages: Math.ceil(raw.total / raw.limit),
  },
});

export const getMentors = async (
  params: MentorParams
): Promise<NormalisedMentorsResponse> => {
  const { data } = await apiClient.get<MentorsResponse>("/mentors", {
    params,
  });
  return normalise(data);
};
